module.exports = __webpack_public_path__ + "img/ISS.39b3eebd.svg";